import React from "react";
import AetherPanelPage from "../components/Projects/AetherPanelPage";
import ProjectsAnimation from "../components/Projects/ProjectsAnimation";

const AetherPanel: React.FC = () => {
  return (
    <div className="z-30 relative">
      <ProjectsAnimation />
      <AetherPanelPage />
    </div>
  );
};

export default AetherPanel;
